import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { DataService } from './data.service';
import { PostInterface } from '../models/blog.model';
import { environment } from '../../../environments/environment';
import { catchError } from 'rxjs/operators';
import { SentryService } from './sentry.service';

@Injectable({
    providedIn: 'root'
})
export class BlogService {
    siteId: string = '';

    constructor(private dataService: DataService, private http: HttpClient, private sentryService: SentryService) {
        this.dataService.getSiteId().subscribe(siteId => {
            this.siteId = siteId;
        });
    }

    getArticles(siteId?: string, paginationSize?: number, LastEvaluatedKey?: number): Observable<PostInterface[]> {
        const idSite = siteId ? siteId : this.siteId;
        if (LastEvaluatedKey) {
            return this.http.post<PostInterface[]>(`${environment.baseUrl}/blog/getArticles/${idSite}?public=true${paginationSize ? '&paginationSize=' + paginationSize : ''}`, { LastEvaluatedKey }, { headers: { Anonymous: 'Anonymous' } }).pipe(
                catchError(err => {
                    this.handleError(err);
                    return throwError(err);
                })
            );
        } else {
            return this.http.get<PostInterface[]>(`${environment.baseUrl}/blog/getArticles/${idSite}?public=true${paginationSize ? '&paginationSize=' + paginationSize : ''}`, { headers: { Anonymous: 'Anonymous' } }).pipe(
                catchError(err => {
                    this.handleError(err);
                    return throwError(err);
                })
            );
        }
    }

    getAllArticles(): Observable<PostInterface[]> {
        return this.http.get<PostInterface[]>(`${environment.baseUrl}/blog/getArticles/${this.siteId}?allPublic=true`, { headers: { Anonymous: 'Anonymous' } }).pipe(
            catchError(err => {
                this.handleError(err);
                return throwError(err);
            })
        );
    }

    getArticle(siteId, createdAt): Observable<PostInterface> {
        return this.http.get<PostInterface>(`${environment.baseUrl}/blog/getArticle/${siteId}/${createdAt}?public=true`, { headers: { Anonymous: 'Anonymous' } }).pipe(
            catchError(err => {
                this.handleError(err);
                return throwError(err);
            })
        );
    }

    getArticlesPublicByCategory(siteId, category): Observable<PostInterface[]> {
        // tslint:disable-next-line:max-line-length
        return this.http.get<PostInterface[]>(`${environment.baseUrl}/blog/public/getArticlesByCategory/${siteId}/${category}`, { headers: { Anonymous: 'Anonymous' } }).pipe(
            catchError(err => {
                this.handleError(err);
                return throwError(err);
            })
        );
    }
    public handleError(error) {
        this.sentryService.errorHandling(error, 'Blog-service', error.error.message ? error.error.message : (error.message ? error.message : error));
        return throwError(error);
    }
}
